/* @generated */
// prettier-ignore
if (Intl.RelativeTimeFormat && typeof Intl.RelativeTimeFormat.__addLocaleData === 'function') {
  Intl.RelativeTimeFormat.__addLocaleData({
    "data": {
      "day": {
        "-1": "inanahi",
        "0": "i tēnei rā",
        "1": "āpōpō",
        "future": {
          "other": "+{0} r."
        },
        "past": {
          "other": "-{0} r."
        }
      },
      "day-narrow": {
        "-1": "inanahi",
        "0": "i tēnei rā",
        "1": "āpōpō",
        "future": {
          "other": "+{0} r"
        },
        "past": {
          "other": "-{0} r"
        }
      },
      "day-short": {
        "-1": "inanahi",
        "0": "i tēnei rā",
        "1": "āpōpō",
        "future": {
          "other": "+{0} r"
        },
        "past": {
          "other": "-{0} r."
        }
      },
      "hour": {
        "0": "i tēnei hāora",
        "future": {
          "other": "+{0} h"
        },
        "past": {
          "other": "-{0} h"
        }
      },
      "hour-narrow": {
        "0": "i tēnei hāora",
        "future": {
          "other": "+{0} h."
        },
        "past": {
          "other": "-{0} h."
        }
      },
      "hour-short": {
        "0": "i tēnei hāora",
        "future": {
          "other": "+{0} h."
        },
        "past": {
          "other": "-{0} h."
        }
      },
      "minute": {
        "0": "i tēnei meneti",
        "future": {
          "other": "+{0} men"
        },
        "past": {
          "other": "-{0} men"
        }
      },
      "minute-narrow": {
        "0": "i tēnei meneti",
        "future": {
          "other": "+{0} men"
        },
        "past": {
          "other": "-{0} men"
        }
      },
      "minute-short": {
        "0": "i tēnei meneti",
        "future": {
          "other": "+{0} men."
        },
        "past": {
          "other": "-{0} men."
        }
      },
      "month": {
        "-1": "i tērā marama",
        "0": "i tēnei marama",
        "1": "ā tērā marama",
        "future": {
          "other": "+{0} m"
        },
        "past": {
          "other": "-{0} m"
        }
      },
      "month-narrow": {
        "-1": "i tērā m.",
        "0": "i tēnei m.",
        "1": "ā tērā m.",
        "future": {
          "other": "+{0} m."
        },
        "past": {
          "other": "-{0} m."
        }
      },
      "month-short": {
        "-1": "i tērā m.",
        "0": "i tēnei m.",
        "1": "ā tērā m.",
        "future": {
          "other": "+{0} m."
        },
        "past": {
          "other": "-{0} m."
        }
      },
      "nu": ["latn"],
      "quarter": {
        "-1": "hauwhā whakamutunga",
        "0": "tēnei hauwhā",
        "1": "tērā hauwhā",
        "future": {
          "other": "+{0} hwh"
        },
        "past": {
          "other": "-{0} hwh"
        }
      },
      "quarter-narrow": {
        "-1": "hauwhā whakamutunga",
        "0": "tēnei hauwhā",
        "1": "tērā hauwhā",
        "future": {
          "other": "+{0} Hwh"
        },
        "past": {
          "other": "-{0} hwh"
        }
      },
      "quarter-short": {
        "-1": "hauwhā whakamutunga",
        "0": "tēnei hauwhā",
        "1": "tērā hauwhā",
        "future": {
          "other": "+{0} hwh"
        },
        "past": {
          "other": "-{0} hwh"
        }
      },
      "second": {
        "0": "ināianei",
        "future": {
          "other": "+{0} h"
        },
        "past": {
          "other": "-{0} h"
        }
      },
      "second-narrow": {
        "0": "ināianei",
        "future": {
          "other": "+{0} h"
        },
        "past": {
          "other": "-{0} h"
        }
      },
      "second-short": {
        "0": "ināianei",
        "future": {
          "other": "+{0} h."
        },
        "past": {
          "other": "-{0} h."
        }
      },
      "week": {
        "-1": "i tērā wiki",
        "0": "i tēnei wiki",
        "1": "ā tērā wiki",
        "future": {
          "other": "+{0} w"
        },
        "past": {
          "other": "-{0} w"
        }
      },
      "week-narrow": {
        "-1": "i tērā w.",
        "0": "i tēnei w.",
        "1": "ā tērā w.",
        "future": {
          "other": "+{0} w"
        },
        "past": {
          "other": "-{0} w"
        }
      },
      "week-short": {
        "-1": "i tērā w.",
        "0": "i tēnei w.",
        "1": "ā tērā w.",
        "future": {
          "other": "+{0} w"
        },
        "past": {
          "other": "-{0} w"
        }
      },
      "year": {
        "-1": "i tērā tau",
        "0": "i tēnei tau",
        "1": "ā tērā tau",
        "future": {
          "other": "ā te {0} tau"
        },
        "past": {
          "other": "i te {0} tau"
        }
      },
      "year-narrow": {
        "-1": "i tērā tau",
        "0": "i tēnei tau",
        "1": "ā tērā tau",
        "future": {
          "other": "ā te {0} tau"
        },
        "past": {
          "other": "i te {0} tau"
        }
      },
      "year-short": {
        "-1": "i tērā tau",
        "0": "i tēnei tau",
        "1": "ā tērā tau",
        "future": {
          "other": "ā te {0} tau"
        },
        "past": {
          "other": "i te {0} tau"
        }
      }
    },
    "locale": "mi"
  });
}